import { createRouter, createWebHistory } from 'vue-router';
import { isAuthenticated } from './services/authService.js';
import { reqQueryMemberInfo } from '@vrp/services/apiServer.js';
import { useStore } from './store.js';
import { useStoreData } from './store_data.js';
import { commontrackEvent } from '@vrp/services/googleAnalytics.js';
import { computed } from 'vue';
const VrpHomeView = () => import('./views/home/VrpHomeView.vue');
const VrpHomeAfterLoginView = () =>
	import('./views/home/VrpHomeAfterLoginView.vue');
const VrpMainView = () => import('./views/VrpMainView.vue');
const VrpAccountView = () => import('./views/accountManage/VrpAccountView.vue');
const VrpAccountManageView = () =>
	import('./views/accountManage/VrpAccountManageView.vue');
const VrpDashBoardView = () => import('./views/dashboard/VrpDashBoardView.vue');

const VrpRoutePlanView = () => import('./views/routePlan/VrpRoutePlanView.vue');
const VrpRoutePlanAddView = () =>
	import('./views/routePlan/routePlanAdd/VrpRoutePlanAddView.vue');
const VrpRoutePlanEditView = () =>
	import('./views/routePlan/routePlanEdit/VrpRoutePlanEditView.vue');
const VrpRoutePlanOptionView = () =>
	import('./views/routePlan/routePlanOption/VrpRoutePlanOptionView.vue');
const VrpRoutePlanCompleteView = () =>
	import('./views/routePlan/routePlanComplete/VrpRoutePlanCompleteView.vue');
const VrpRoutePlanUnassignView = () =>
	import('./views/routePlan/routePlanUnassign/VrpRoutePlanUnassignView.vue');

const VrpRoutePlanFixView = () =>
	import('./views/routePlanFix/VrpRoutePlanFixView.vue');
const VrpRoutePlanFixAddView = () =>
	import('./views/routePlanFix/routePlanFixAdd/VrpRoutePlanFixAddView.vue');
const VrpRoutePlanFixOptionView = () =>
	import(
		'./views/routePlanFix/routePlanFixOption/VrpRoutePlanFixOptionView.vue'
	);
const VrpRoutePlanFixCompleteView = () =>
	import(
		'./views/routePlanFix/routePlanFixComplete/VrpRoutePlanFixCompleteView.vue'
	);

const VrpDriverView = () => import('./views/driverManage/VrpDriverView.vue');
const VrpDriverManageView = () =>
	import('./views/driverManage/VrpDriverManageView.vue');
const VrpRegionView = () => import('./views/regionManage/VrpRegionView.vue');
const VrpRegionManageView = () =>
	import('./views/regionManage/VrpRegionManageView.vue');
const VrpJoinView = () => import('./views/VrpJoin/VrpJoinView.vue');
const VrpJoinTermsAgreeView = () =>
	import('./views/VrpJoin/VrpJoinTermsAgreeView.vue');
const VrpJoinInfoView = () => import('./views/VrpJoin/VrpJoinInfoView.vue');
const VrpDeliveryHistoryView = () =>
	import('./views/deliveryHistory/VrpDeliveryHistoryView.vue');
const VrpDeliveryHistoryDetailView = () =>
	import('./views/deliveryHistory/VrpDeliveryHistoryDetailView.vue');
const VrpNoticeView = () => import('./views/notice/VrpNoticeView.vue');
const VrpNoticeList = () => import('./views/notice/VrpNoticeList.vue');
const VrpNoticeDetail = () => import('./views/notice/VrpNoticeDetail.vue');
const VrpStatsView = () => import('./views/stats/VrpStatsView.vue');
const VrpMaintenanceView = () =>
	import('./views/maintenance/VrpMaintenanceView.vue');

const routes = [
	{
		name: 'Home',
		path: '/tms/home',
		component: VrpHomeView,
		props: true,
	},
	{
		name: 'Maintenance',
		path: '/tms/maintenance',
		component: VrpMaintenanceView,
		props: true,
	},
	{
		name: 'Join',
		path: '/tms/join',
		component: VrpJoinView,
		redirect: '/tms/join/termsAgree',
		props: true,
		children: [
			{
				name: 'TermsAgree',
				path: 'termsAgree',
				component: VrpJoinTermsAgreeView,
				props: true,
			},
			{
				name: 'Info',
				path: 'info',
				component: VrpJoinInfoView,
				props: true,
			},
		],
	},
	{
		name: 'Main',
		path: '/tms/main',
		component: VrpMainView,
		props: true,
		redirect: '/tms/main/dashboard',
		children: [
			{
				name: 'HomeAfterLogin',
				path: 'homeAfterLogin',
				component: VrpHomeAfterLoginView,
				props: true,
			},
			{
				name: 'Account',
				path: 'account',
				component: VrpAccountView,
				props: true,
				children: [
					{
						name: 'AccountManage',
						path: 'accountManage',
						component: VrpAccountManageView,
						props: true,
					},
				],
			},
			{
				name: 'DashBoard',
				path: 'dashboard',
				component: VrpDashBoardView,
				props: true,
			},
			{
				name: 'RoutePlan',
				path: 'routePlan',
				component: VrpRoutePlanView,
				redirect: '/tms/main/routePlan/add',
				props: true,
				children: [
					{
						name: 'Add',
						path: 'add',
						component: VrpRoutePlanAddView,
					},
					{
						name: 'Edit',
						path: 'edit',
						component: VrpRoutePlanEditView,
					},
					{
						name: 'Option',
						path: 'option',
						component: VrpRoutePlanOptionView,
					},
					{
						name: 'Complete',
						path: 'complete',
						component: VrpRoutePlanCompleteView,
					},
					{
						name: 'Unassign',
						path: 'unassign',
						component: VrpRoutePlanUnassignView,
					},
				],
			},
			{
				name: 'RoutePlanFix',
				path: 'routePlanFix',
				component: VrpRoutePlanFixView,
				redirect: '/tms/main/routePlanFix/add',
				props: true,
				children: [
					{
						name: 'FixAdd',
						path: 'add',
						component: VrpRoutePlanFixAddView,
						// props: true,
					},
					{
						name: 'FixOption',
						path: 'option',
						component: VrpRoutePlanFixOptionView,
						// props: true,
					},
					{
						name: 'FixComplete',
						path: 'complete',
						component: VrpRoutePlanFixCompleteView,
						// props: true,
					},
				],
			},
			{
				name: 'Driver',
				path: 'driver',
				component: VrpDriverView,
				props: true,
				children: [
					{
						name: 'DriverManage',
						path: 'driverManage',
						component: VrpDriverManageView,
						props: true,
					},
				],
			},
			{
				name: 'Region',
				path: 'region',
				component: VrpRegionView,
				props: true,
				children: [
					{
						name: 'RegionManage',
						path: 'regionManage',
						component: VrpRegionManageView,
						props: true,
					},
				],
			},
			{
				name: 'History',
				path: 'history',
				component: VrpDeliveryHistoryView,
				props: true,
			},
			{
				name: 'HistoryDetail',
				path: 'history/:id',
				component: VrpDeliveryHistoryDetailView,
				props: true,
			},
			{
				name: 'Notice',
				path: 'notice',
				component: VrpNoticeView,
				props: true,
				children: [
					{
						name: 'NoticeList',
						path: 'list',
						component: VrpNoticeList,
						props: true,
					},
					{
						name: 'NoticeDetail',
						path: 'list/:notice_id',
						component: VrpNoticeDetail,
						props: true,
					},
				],
			},
			{
				name: 'Stats',
				path: 'stats',
				component: VrpStatsView,
				props: true,
			},
		],
	},
];

const sendGoogleAnlistic = async function (to) {
	const store = useStore();
	const memberInfo = computed(() => {
		return store.memberInfo;
	});

	//인증이 안되어 있으면 memberInfo를 초기화 한다.
	if (isAuthenticated() === false) {
		store.setMemberInfo(null);
	}

	//memberInfo가 없고 인증이 안되어 있으면, memberInfo를 받아 온다
	if (memberInfo.value === null && isAuthenticated()) {
		const response = await reqQueryMemberInfo({});
		if (response.status.code === 0) {
			store.setMemberInfo(response);
		}
	}

	//memberInfo가 있고 인증이 되어 있으면
	if (memberInfo.value && isAuthenticated()) {
		commontrackEvent(`${to.name}`, memberInfo.value.user_id, 'page_search', '');
	} else {
		commontrackEvent(`${to.name}`, '', 'page_search', '');
	}
};

const router = createRouter({
	mode: 'history',
	history: createWebHistory(),
	routes,
});

//Navigation guard
router.beforeEach(async (to, from, next) => {
	const storeData = useStoreData();

	if (to.name === 'Home' && isAuthenticated()) {
		next({ path: '/tms/main/dashboard' });
	} else if (
		to.name !== 'Home' &&
		!to.path.startsWith('/tms/join') &&
		!to.path.startsWith('/tms/maintenance') &&
		!isAuthenticated()
	) {
		if (process.env.VUE_APP_BUILD_MODE === 'MAIN') {
			commontrackEvent('Home', 'no_user_id', '', '');
		}
		next({ name: 'Home' });
	} else if (
		to.path === '/tms/join/info' &&
		from.path !== '/tms/join/termsAgree'
	) {
		if (process.env.VUE_APP_BUILD_MODE === 'MAIN') {
			commontrackEvent('TermsAgree', 'no_user_id', '', '');
		}
		next({ path: '/tms/join/termsAgree' });
	} else {
		//Main환경에서만 구글 애널리스틱 동작하도록 수정
		if (process.env.VUE_APP_BUILD_MODE === 'MAIN') {
			sendGoogleAnlistic(to);
		}

		//route 이동 할 때는, 무조건 Map 초기화 해야됨, 단, Region은 자체적으로 초기화
		// const storeMap = useStoreMap();
		//if (from.name === 'RegionManage' || from.name === 'DriverManage') {
		if (from.name === 'RegionManage' || from.name === 'DriverManage') {
			// storeMap.initDrawRegion();
			//storeMap.setMapService(null);
		} else if (
			((from.name === 'History' && to.name === 'HistoryDetail') ||
				(to.name === 'History' && from.name == 'HistoryDetail')) === false
		) {
			//저장해둔 배송내역 옵션 초기화
			storeData.setDeliveryHistoryOption(null);
			storeData.setDeliveryHistoryData(null);
		}
		// await storeMap.setMapService(null);

		storeData.resetFixUploadedExcelData();
		storeData.resetFixSelectSheetData();
		storeData.resetFixSelectSheetRowIndex();
		storeData.resetFixAddrRefineResultData();
		// ✅ 여기서 새로고침 조건 체크
		const needForceReload =
			(from.path === '/tms/main/routePlan/unassign' &&
				to.path !== '/tms/main/routePlan/complete') ||
			(from.path === '/tms/main/routePlanFix/option' &&
				to.path !== '/tms/main/routePlanFix/complete') ||
			(from.path === '/tms/main/routePlanFix/add' &&
				to.path !== '/tms/main/routePlanFix/option') ||
			(from.path === '/tms/main/routePlan/add' &&
				to.path !== '/tms/main/routePlan/edit') ||
			(from.path === '/tms/main/routePlan/edit' &&
				to.path !== '/tms/main/routePlan/option') ||
			(from.path === '/tms/main/routePlan/option' &&
				to.path !== '/tms/main/routePlan/edit' &&
				from.path === '/tms/main/routePlan/option' &&
				to.path !== '/tms/main/routePlan/complete') ||
			from.path === '/tms/main/routePlanFix/complete';

		if (needForceReload) {
			next();
			setTimeout(() => {
				const url = new URL(window.location.href);
				url.searchParams.set('cache_buster', Date.now());
				window.location.replace(url.href);
			}, 100);
		} else {
			next();
		}
	}
});

export default router;
